/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import CollapseGroupItem from './CollapseGroupItem';
import { getConnectivityColor, isOnline } from '../../../utils/ConnectionStatusUtils';
import { TerminalDetails } from '../../../shared/entities/terminal';

const SpaceVehicleStatusCollapseGroupItem = ({
  terminal,
  label = 'Status',
}: {
  terminal: TerminalDetails | undefined;
  label?: string;
}) => {
  const getSpaceVehicleStatus = (connectivityStatus: string | undefined) => {
    // TODO: Change logic to determine Connected/Disconnected once insights supports M&C API
    return isOnline(connectivityStatus) ? 'Connected' : 'Disconnected';
  };

  return (
    <CollapseGroupItem
      id="spaceVehicleStatus"
      label={label}
      value={terminal && getSpaceVehicleStatus(terminal.connectivityStatus)}
      color={getConnectivityColor((terminal || ({} as TerminalDetails)).connectivityStatus)}
    />
  );
};

export default SpaceVehicleStatusCollapseGroupItem;
